// extracted by mini-css-extract-plugin
export default {"home":"Home_home__u9tIb","void":"Home_void__MM5Gd"};